import angular from "angular"

angular
  .module("uCountitUiApp")
  .controller("OverviewEmbedCtrl", ($scope, usSpinnerService, HeaderSrv) => {
    ;(async () => {
      usSpinnerService.spin("spinner")
      $scope.onLoad = () => {
        usSpinnerService.stop("spinner")
      }
      $scope.uiVer = "v2"

      const store = await HeaderSrv.fetchCurrentStore()
      if (store.orgType === "store") {
        $scope.overviewSrc = `/v2/embed/overview/stores/${store._id}`
      } else if (store.orgType === "storegroup") {
        $scope.overviewSrc = `/v2/embed/overview/storegroups/${store._id}`
      } else {
        const company = await HeaderSrv.fetchCurrentCompany()
        $scope.overviewSrc = `/v2/embed/overview/companies/${company._id}`
      }
    })()
  })
